import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

export async function getOnboardingProgress() {
  return await apiService.apiCall(
    `${baseURL}api/v2/onboarding/progress`,
    "GET",
    {},
  );
}

export async function getTourSamples() {
  return await apiService.apiCall(
    `${baseURL}api/v2/onboarding/tour-samples`,
    "GET",
    {},
  );
}
